module.exports = __webpack_public_path__ + "img/index.1631cb62.jpg";